module.exports = {"450223100":"鹿寨镇","450223102":"中渡镇","450223103":"寨沙镇","450223104":"平山镇","450223105":"黄冕镇","450223106":"四排镇","450223201":"江口乡","450223202":"导江乡","450223203":"拉沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450223.json
// module id = 2215
// module chunks = 0